import { createAction } from '@reduxjs/toolkit'
import {
  Client,
  File,
  Organization,
  Project,
  User,
  UserRecentFile,
} from '../models/Organization'
import { UserRole } from '../models/AccessControl'

export const addClients = createAction<Client[]>('organization/addClients')
export const addClientProjects = createAction<{
  clientId: string
  projects: Project[]
}>('organization/addClientProjects')
export const addClient = createAction<Client>('organization/addClient')
export const removeClient = createAction<Client>('organization/removeClient')
export const addProjects = createAction<Project[]>('organization/addProjects')
export const addFiles = createAction<File[]>('organization/addFiles')
export const addFile = createAction<File>('organization/addFile')
export const removeFile = createAction<File>('organization/removeFile')
export const addProject = createAction<Project>('organization/addProject')
export const removeProject = createAction<Project>('organization/removeProject')
export const updateSelectedFile = createAction<File | undefined>(
  'organization/updateSelectedFile',
)
export const updateFile = createAction<{
  fileId: number | null
  newFile: File
}>('organization/updateFile')
export const updateClients = createAction<boolean>('organization/updateClients')
export const fetchClients = createAction<boolean>('organization/fetchClients')
export const showAddFileModal = createAction<boolean>(
  'organization/showAddFileModal',
)
export const showEditFileModal = createAction<boolean>(
  'organization/showEditFileModal',
)
export const showAddProjectModal = createAction<boolean>(
  'organization/showAddProjectModal',
)
export const showError = createAction<boolean>('organization/showError')
export const showErrorMessage = createAction<string>(
  'organization/showErrorMessage',
)
export const showAddClientDialog = createAction<boolean>(
  'organization/showAddClientDialog',
)
export const showAddOrganizationDialog = createAction<boolean>(
  'organization/showAddOrganizationDialog',
)
export const showAssignProjectDialog = createAction<boolean>(
  'organization/showAssignProjectDialog',
)
export const showAssignEngineerDialog = createAction<boolean>(
  'organization/showAssignEngineerDialog',
)
export const updateSelectedClientId = createAction<number>(
  'organization/updateSelectedClientId',
)
export const updateSelectedClient = createAction<Client | undefined>(
  'organization/updateSelectedClient',
)
export const updateSelectedProject = createAction<Project | undefined>(
  'organization/updateSelectedProject',
)
export const setSelectedProjectId = createAction<number | undefined>(
  'organization/setSelectedProjectId',
)
export const updateSelectedOrganization = createAction<
  Organization | undefined
>('organization/updateSelectedOrganization')
export const updateUser = createAction<{ userId: number; newInfo: User }>(
  'organization/updateUser',
)
export const addUserRoles = createAction<UserRole[]>(
  'organization/addUserRoles',
)
export const addUserRecentFiles = createAction<UserRecentFile[]>(
  'organization/addUserRecentFiles',
)
export const showUpdatePaymentMethodDialog = createAction<boolean>(
  'organization/showUpdatePaymentMethodDialog',
)
export const showOneTimeServicePaymentDialog = createAction<boolean>(
  'organization/showOneTimeServicePaymentDialog',
)
export const setSearchFilter = createAction<string>(
  'organization/setSearchFilter',
)
